module.exports = __webpack_public_path__ + "img/224.9d323512.jpg";